import React, {Component} from 'react';

import {FormControl } from '@mui/material/';


import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import FormLabel from '@mui/material/FormLabel';
//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
class RadioVF extends Component {

  constructor(props) {
    super(props);
   
    this.state = {           

        optionValue:"",
        
    };

    this.handleChange = this.handleChange.bind(this);
   
  }
  
  
    componentDidMount() { 
       
        this.setState({optionValue  : this.props.value});
       
       // alert(this.state.optionValue);
    }


    componentDidUpdate(prevProps) {
            
    }

    handleChange(event) {  
        console.log(event.target);
        this.setState({optionValue: event.target.value});  
    }
  
    render() {  
        return (
            <FormControl>
            <FormLabel id="demo-row-radio-buttons-group-label">{this.props.id}</FormLabel>
            <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"                                        
                onChange={this.handleChange}
                value={this.state.optionValue}                                        
            >
                <FormControlLabel  value="T" control={<Radio id={this.props.id} />} label="Vrai" />
                <FormControlLabel  value="F" control={<Radio id={this.props.id} />} label="Faux" />   
               
            </RadioGroup>
            </FormControl>
        );
    }
}

export default RadioVF;